import React, { useEffect, useRef, useState } from "react"
import Select from 'react-select';
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import Input from "../../components/utils/Input";
import { updateOtherExpenditure } from "../../action/cassa";

const optionsTypeTransaction = [
    {label: 'Наличные', value: 'cash'},
    {label: 'Безнал.', value: 'noncash'}
];

const OtherExpendituresEditArticles = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const articlesExpenditures = useSelector(state => state.handbook.articlesExpenditures);
    const detailArticle = useSelector(state => state.cassa.detailArticle);

    const [article, setArticle] = useState({
        visible_datetime: null,
        articleId: null,
        name: null,
        sum: null,
        typeTransaction: null,
        author: null,
        payment: 'unpaid',
        point: null,
        workingshift: null,
        comment: null
    });
    const [availableArticles, setAvailableArticles] = useState(null);

    useEffect(() => {
        let filteredArticles = articlesExpenditures;

        if(detailArticle) {
            setArticle(detailArticle);
        } else {
            onClose();
        }

        if(detailArticle.typeTransaction) {
            filteredArticles = articlesExpenditures.filter(item => item.typeTransaction === detailArticle.typeTransaction || item.typeTransaction === 'all');
        }

        setAvailableArticles(filteredArticles.map(item => ({ label: item.name, value: item.id }))); 
        // eslint-disable-next-line
    }, [])

    const onClose = () => dispatch(setActiveModalAction({ field: 'otherExpendituresEditArticles', value: null }));
    
    useOnClickOutside(ref, onClose);

    const onSubmit = () => {
        const data = {...article};

        dispatch(updateOtherExpenditure(data));

        onClose();
    }

    const isValidArticle = () => {
        if(!article.sum || !article.name || !article.articleId || !article.typeTransaction || !article.visible_datetime) 
            return false;
        return true;
    }

    const setDataArticle = (field) => (e) => {
        const data = {...article};

        if (field === 'articleId') {
            data.articleId = e.value;
            data.name = e.label;
        } else {
            data[field] = e.value;
        }
        
        setArticle(data);
    }

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div ref={ref} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"> Изменение статьи расхода </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Дата *</div>
                                <input
                                disabled={true}
                                className="form-control"
                                placeholder="Дата"
                                type="datetime-local"                                
                                value={detailArticle.visible_datetime.slice(0, -8)}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Тип *</div>                               
                                <Select
                                    isDisabled={true}
                                    placeholder='Тип'
                                    value={optionsTypeTransaction.find((el) => el.value === article.typeTransaction)}                                    
                                    options={optionsTypeTransaction}
                                    noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Статья *</div>                               
                                <Select
                                    isDisabled={!article.typeTransaction}
                                    placeholder='Статья'
                                    value={article.articleId ? {value: article.id, label: article.name} : ''}
                                    onChange={setDataArticle('articleId')}
                                    options={availableArticles}
                                    noOptionsMessage={() => 'Нет статей'}
                                />
                            </div>
                            <Input
                            disabled={true}
                            label='Сумма'
                            type="number"
                            required={true}                            
                            value={article.sum}
                            placeholder='Сумма'
                            />
                            <Input
                            disabled={true}
                            textarea={true}
                            label='Примечание'
                            value={article.comment}
                            placeholder='Примечание'
                            />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                            <button disabled={!isValidArticle()} type="button" onClick={onSubmit} className='btn btn-primary'>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(OtherExpendituresEditArticles);